import { Component, OnInit, EventEmitter } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { EventService } from '../event.service';
import { PageService } from '../../common/page.service';
import {MdSnackBar} from '@angular/material';

@Component({
  selector: 'event-page-form',
  templateUrl: './event-page-form.component.html',
  styleUrls: ['./event-page-form.component.css', '../admin.css'],
  providers: [PageService, EventService],
})
export class EventPageFormComponent implements OnInit {

 pageForm: any;
 eventId: any;
 event: any;
 pageId: any;
 page: any;
 spinner: boolean = false;

 constructor(private formBuilder: FormBuilder, private pageService: PageService, private eventService: EventService, private activatedRoute: ActivatedRoute, private snackBar: MdSnackBar){
  this.pageForm = this.formBuilder.group({
   'id': [''],
   'ordr': ['', Validators.required],
   'title': ['', Validators.required],
   'displayFor': [''],
   'publish': [''],
   'content': [''],
   'mobileContent': [''],
   'androidContent':['']
  });
  this.page = this.pageForm.value;
  this.activatedRoute.queryParams.subscribe((params: Params) => {
   this.eventId = params.id;
   this.eventService.getEvents({eventId:params.id}).subscribe(
    response => {
     this.spinner = false;
     this.event = response[0];
    },
    error => {
     this.spinner = false;
    }
   );
  });
 }

 ngOnInit() {
 }

 onSave = new EventEmitter();

 savePage() {
   this.spinner = true;
   var params = this.pageForm.value;
   params.eventId = this.eventId;
   this.pageService.savePage(params).subscribe(response => {
    this.spinner = false;
    if(response.status)
    this.onSave.emit();
    else
    this.snackBar.open(response.msg, '', {duration: 4000});
   });
 }

 formValid(frm){
  var flag = true;
  if(!this.pageForm.valid)
  flag = false;
  if(flag && this.page.ordr<=0)
  flag = false;
  return flag;
 }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/event-page-form/event-page-form.component.ts